var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"t0 l0 w-100 pabs noevents font-nats bg-danger t0 pin-top text-light p-2 d-flex"},[_c('icon',{attrs:{"name":"mdi.alert-outline"}}),_c('span',{staticClass:"ml-2",domProps:{"innerHTML":_vm._s(_vm.title)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }